// extracted by mini-css-extract-plugin
export default {"botton-holder-container":"Footer_botton-holder-container__XFJJK"};